import React, { useEffect, useState, useContext } from 'react';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import logo from '../images/logo_1.png';
import HeaderComponent from './HeaderComponent';
import '../styles/Home.css'
import TablaInventario from './TablaInventario';
import ModalContainer from './ModalContainer';
import FormNuevoProducto from './FormNuevoProducto';
import { apiService, setupInterceptors  } from '../services/apiService';
import { AuthContext } from '../context/AuthContext';
import FormCategoriaProducto from './FormCategoriaProducto';

const Inventario = ({ toast }) => {

    const [showModal, setShowModal] = useState(false);
    const [showModalCategoria, setShowModalCategoria] = useState(false);

    const { logoutUser } = useContext(AuthContext);
    const [ categorias, setCategorias ] = useState([])

    const [ proveedores, setProveedores ] = useState([])

    const [ productos, setProductos ] = useState([])

    const openModal = () => setShowModal(true);
    const hideModal = () => setShowModal(false);

    const openModalCategoria = () => setShowModalCategoria(true);
    const hideModalCategoria = () => setShowModalCategoria(false);


    useEffect(() => {
        // Configura el interceptor con la función de logout
        setupInterceptors(logoutUser);
        getProductos();
        getCategoriasProducto(); // Llama a la función para obtener datos
        getProveedores();
    }, [logoutUser]);

    const getCategoriasProducto = async () => {
        try {
            const response = await apiService.fetchData('categorias_producto/');
            const categoriasList = response.data.map(categoria => ({
                id: categoria.id,
                categoria: categoria.categoria
            }));
            setCategorias(categoriasList); 
        } catch (error) {
            console.error('Error al obtener datos:', error.response ? error.response.data : error.message);
        }
    };

    const getProveedores = async () => {
        try {
            const response = await apiService.fetchData('proveedores/');
            setProveedores(response.data); 
        } catch (error) {
            console.error('Error al obtener datos:', error.response ? error.response.data : error.message);
        }
    };

    const getProductos = async () => {
        try {
            const response = await apiService.fetchData('productos/');
            const productosList = response.data.map(producto => ({
                id: producto.id,
                categoria_nombre: producto.categoria_nombre,
                codigo: producto.codigo,
                nombre: producto.nombre,
                proveedor_nombre: producto.proveedor_nombre,
                precio_producto: producto.precio_producto,
                ult_actualizacion_precio: producto.ult_actualizacion_precio,
                cantidad_disponible: producto.cantidad_disponible
            }));
            setProductos(productosList); 
        } catch (error) {
            console.error('Error al obtener datos:', error.response ? error.response.data : error.message);
        }
    };

    const postCategoriaProducto = async (data) => {
        try {
            const response = await apiService.postData('categorias_producto/', data);
            const nuevaCategoria = {
                id: response.data.id, // Usa los datos recibidos de la API
                categoria: response.data.categoria
            };
            
            // Actualiza el estado de las categorías agregando la nueva categoría
            setCategorias(prevCategorias => [...prevCategorias, nuevaCategoria]);

            toast.current.show({severity:'success', summary: 'Solicitud Exitosa', detail:'Categoria creada exitosamente!', life: 2000});

            
            // Opcional: cierra el modal tras agregar la nueva categoría
            hideModalCategoria();

        } catch (error) {
            toast.current.show({severity:'error', summary: 'Error', detail:{error}, life: 3000});
            console.error('Error al realizar la creacion:', error.response ? error.response.data : error.message);
        }
    };

    const postProducto = async (data) => {
        try {
            const response = await apiService.postData('productos/', data);
            const nuevoProducto = {
                id: response.data.id,
                categoria_nombre: response.data.categoria_nombre,
                codigo: response.data.codigo,
                nombre: response.data.nombre,
                proveedor_nombre: response.data.proveedor_nombre,
                precio_producto: response.data.precio_producto,
                ult_actualizacion_precio: response.data.ult_actualizacion_precio,
                cantidad_disponible: response.data.cantidad_disponible
            };
            
            // Actualiza el estado de las categorías agregando la nueva categoría
            setProductos(prevProductos => [...prevProductos, nuevoProducto]);

            toast.current.show({severity:'success', summary: 'Solicitud Exitosa', detail:'Producto creado exitosamente!', life: 2000});

            
            // Opcional: cierra el modal tras agregar la nueva categoría
            hideModal();

        } catch (error) {
            toast.current.show({severity:'error', summary: 'Error', detail:{error}, life: 3000});
            console.error('Error al realizar la creacion:', error.response ? error.response.data : error.message);
        }
    };

    return (
        <>
            <HeaderComponent title={"Inventario"} />
            <div className='col-12 ml-6' style={{ minWidth:"95%", maxWidth:"95%" }}>
                <div className='ml-2' style={{ fontSize:"20px" }}>
                    <p>
                        Bienvenid@ al Inventario
                    </p>
                </div>
                <div className='col-12'>
                    <Button severity='warning' className='ml-2 font-buttons w-auto' icon='pi pi-plus' label='Nueva Categoria' size='small'
                        onClick={() => openModalCategoria(true)}
                    ></Button>
                    <Button className='ml-2 font-buttons w-auto' icon='pi pi-plus' label='Nuevo Producto' size='small'
                        onClick={() => openModal(true)}
                    ></Button>
                </div>
                
                <div className='col-12'>
                    <TablaInventario productos={productos} getProductos={getProductos} toast={toast}/>
                </div>
            </div>
            <ModalContainer
                title="Agregar Producto"
                show={showModal}
                close={hideModal}
                idForm="FormNuevoProducto"
                widthSize="25vw">
                <FormNuevoProducto categorias={categorias} proveedores={proveedores} postProducto={postProducto}></FormNuevoProducto>
            </ModalContainer>

            <ModalContainer
                title="Agregar Categoria"
                show={showModalCategoria}
                close={hideModalCategoria}
                idForm="FormCategoriaProducto"
                widthSize="25vw">
                <FormCategoriaProducto postCategoriaProducto={postCategoriaProducto} />
            </ModalContainer>
        </>
    );
};

export default Inventario;
